











 








const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "AddTeamMemberAvatarButton_teamMembers",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AddTeamMemberModal_teamMembers"
    }
  ],
  "type": "TeamMember",
  "abstractKey": null
};

(node ).hash = "08fa493d695a88e9cd0f2662c91061d6";

export default node;
